module.exports = __webpack_public_path__ + "static/media/logo_dark.1baa45f0.png";